export default __webpack_public_path__ + "static/media/silhouette-guy1.ac489bd6.svg";